<router-outlet></router-outlet>
<a
  *ngIf="whatsappButtonIsVisible  && phoneNumber"
  [href]="whatsappUrl"
  target="_blank"
  class="button-whatsapp"
>
  <i class="bi bi-whatsapp"></i>
</a>
